import React from 'react';

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';

type Props = {
  open: boolean;
  saving?: boolean;

  onClose: () => void;

  onCreate: (payload: {
    name: string;
    description: string;
    weight: number;
  }) => Promise<void>;
};

type State = {
  name: string;
  description: string;
  weight: number;
  error: string;
};

export default class CreateTaskDialog
  extends React.Component<Props, State> {

  state: State = {
    name: '',
    description: '',
    weight: 1,
    error: '',
  };

  componentDidUpdate(previous: Props) {
    if (!previous.open && this.props.open) {
      this.setState({
        name: '',
        description: '',
        weight: 1,
        error: '',
      });
    }
  }

  private create = async () => {
    const name = this.state.name.trim();

    if (!name) {
      this.setState({
        error: 'Task Name is required.',
      });

      return;
    }

    if (
      !Number.isFinite(this.state.weight) ||
      this.state.weight <= 0
    ) {
      this.setState({
        error: 'Task Weight must be greater than zero.',
      });

      return;
    }

    this.setState({
      error: '',
    });

    try {
      await this.props.onCreate({
        name,
        description:
          this.state.description.trim(),
        weight: this.state.weight,
      });
    }
    catch (error: any) {
      this.setState({
        error:
          error?.message ??
          String(error),
      });
    }
  };

  render() {
    const {
      open,
      saving = false,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={
          saving
            ? undefined
            : onClose
        }
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Create New Task
        </DialogTitle>

        <DialogContent>
          <Stack
            spacing={2}
            sx={{ pt: 1 }}
          >
            {this.state.error && (
              <Alert severity="error">
                {this.state.error}
              </Alert>
            )}

            <TextField
              label="Task Name"
              required
              fullWidth
              value={this.state.name}
              disabled={saving}
              onChange={(event) =>
                this.setState({
                  name: event.target.value,
                })
              }
            />

            <TextField
              label="Description"
              multiline
              minRows={3}
              fullWidth
              value={this.state.description}
              disabled={saving}
              onChange={(event) =>
                this.setState({
                  description:
                    event.target.value,
                })
              }
            />

            <TextField
              label="Weight"
              type="number"
              fullWidth
              value={this.state.weight}
              disabled={saving}
              inputProps={{
                min: 0.01,
                step: 0.01,
              }}
              onChange={(event) =>
                this.setState({
                  weight:
                    Number(
                      event.target.value
                    ),
                })
              }
            />

            <Alert severity="info">
              The Task code will be generated
              automatically. The new Task will
              become reusable under this Activity
              and will also be added to the current
              Activity Plan.
            </Alert>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={() => void this.create()}
            disabled={
              saving ||
              !this.state.name.trim()
            }
          >
            Create Task
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}